document.addEventListener("DOMContentLoaded", () => {

    // get elements
    const showMoreBtn = document.querySelector(".showMore_btn");
    const allMembers = document.querySelectorAll('.team-member');

    // hide members by default
    allMembers.forEach( (thisMember) => {
        thisMember.classList.add('hidden');
    })

    // randomly sleect three of them
    const randomMembers = getRandom(allMembers, 3);

    // show the three
    randomMembers.forEach( (thisRandomMember) => {
        thisRandomMember.classList.add('firstshown');
        thisRandomMember.classList.remove('hidden');
    })

    // make show more work
    showMoreBtn.addEventListener('click', toggleShowAll);

})


function getRandom(arr, n) {
    var result = new Array(n),
        len = arr.length,
        taken = new Array(len);
    if (n > len)
        throw new RangeError("getRandom: more elements taken than available");
    while (n--) {
        var x = Math.floor(Math.random() * len);
        result[n] = arr[x in taken ? taken[x] : x];
        taken[x] = --len in taken ? taken[len] : len;
    }
    return result;
}

function toggleShowAll(e) {
    e.preventDefault();
    const team = document.querySelector('.team');
    const showAllStatus = team.dataset.showAll;
    const showMoreBtn = document.querySelector(".showMore_btn");

    // get team members
    if( showAllStatus == "false") {
        const allMembers = document.querySelectorAll('.team-member');
        allMembers.forEach( (thisMember) => {
            thisMember.classList.remove('hidden');

        })
        team.dataset.showAll = "true";
        showMoreBtn.innerText = "Weniger Members anzeigen";
        // scrollToElementInitial(team);

    } else {
        const allMembers = document.querySelectorAll('.team-member');
        allMembers.forEach( (thisMember) => {
            if(!thisMember.classList.contains('firstshown')) {
                thisMember.classList.add('hidden');
            }
        })
        team.dataset.showAll = "false";
        showMoreBtn.innerText = "Weitere Members anzeigen";

        // scroll back to the top of team
        scrollToElement(team);
    }
}

function scrollToElementInitial(element){
    // var offset = 50;
    var elementPosition = element.offsetTop;
    var offsetPosition = elementPosition

    window.scrollTo({
         top: offsetPosition,
         behavior: "smooth"
    });
}

function scrollToElement(element){
    var offset = 50;
    var elementPosition = element.offsetTop;
    var offsetPosition = elementPosition - offset;

    window.scrollTo({
         top: offsetPosition,
         behavior: "smooth"
    });
}